import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Success() {
  const navigate = useNavigate();

  // Redirect to home page after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="container mx-auto px-4 py-16 max-w-4xl">
      <div className="bg-white rounded-lg shadow-md p-8 text-center">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        
        <h1 className="text-3xl font-bold text-gray-800 mb-4">Tack för ditt meddelande!</h1>
        
        <p className="text-lg text-gray-600 mb-6">
          Vi har tagit emot ditt meddelande och återkommer så snart som möjligt.
        </p>
        
        <p className="text-sm text-gray-500 mb-4">
          Du kommer att omdirigeras till startsidan om 5 sekunder.
        </p>
        
        <a 
          href="/" 
          className="inline-block bg-[#A3C1DA] text-white rounded-md py-2 px-6 hover:bg-[#7A98B0] transition-colors"
        >
          Återgå till startsidan
        </a>
      </div>
    </div>
  );
}